import { ClientJS } from 'clientjs'

export const DEVICE_FINGERPRINT_KEY = 'deviceFingerprint'

/**
 * Reads the persisted device fingerprint, generating and storing it on first use.
 *
 * Kept free of app imports so the axios interceptors can call it without cycles.
 * Reads raw localStorage rather than the `store` wrapper for the same reason.
 *
 * The fingerprint is generated once and never recomputed: getFingerprint() hashes
 * volatile browser traits and shifts on browser updates, font installs and
 * resolution changes, so computing it per request would report a new device at
 * random. The value is read inside the function rather than captured at module
 * scope so a cleared localStorage mid-session regenerates instead of serving a
 * stale closure.
 */
export const getDeviceFingerprint = (): string => {
  const stored = localStorage.getItem(DEVICE_FINGERPRINT_KEY)

  if (stored) return stored

  const fingerprint = new ClientJS().getFingerprint().toString()
  localStorage.setItem(DEVICE_FINGERPRINT_KEY, fingerprint)

  return fingerprint
}